import { IEvent } from "modules/event/types";
import { sendPostRequest } from "services/apiService";

interface ValidationErrorData {
  concurrentEvents: IEvent[];
  isValidationError: boolean;
  validationError: string;
}

export class ValidationError extends Error {
  // recheck if we need to export
  public data: null | ValidationErrorData = null;

  constructor(message: string, data: ValidationErrorData) {
    super(message);
    this.data = data;
  }
}

type RestartEventResponse =
  | { event: IEvent }
  | { event: undefined; data: ValidationErrorData; message: string };

export const getRequestURL = (eventId: string) => `/event/${eventId}/restart`;

const request = async (eventId: string) => {
  const resp = await sendPostRequest<
    unknown,
    APIResponse<RestartEventResponse>
  >(getRequestURL(eventId), {});

  if (!resp.event) {
    throw new ValidationError(resp.message ?? resp.error, resp.data);
  }

  return resp.event;
};

export default request;
